import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_settings_workspace from '@/locales/keys/i18n_page_settings_workspace.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { get_sorted_current_workspace_users } from '@/utils/utils_workspace';
import { useTranslation } from 'react-i18next';
import { UserAvatarReadOnly } from '../../_base/UserAvatarReadOnly';

export function WSTableAllTimeCreditsHeader() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_SETTINGS_WORKSPACE);

  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  function render_header() {
    const users = get_sorted_current_workspace_users();

    let header_users = users.map(item => {
      return (
        <span
          key={`WSTableAllTimeCreditsHeader_${item._id}`}
          className={`${md('min-w-[40px] text-[12px]', 'min-w-[100px] h-[50px]')}  flex items-center justify-center ${
            item.user_id == current_workspace_user.user_id ? 'border-r border-dashed border-component-item' : ''
          }`}
        >
          <UserAvatarReadOnly url_relative={item.url_relative_avatar} userName={item.full_name} className="!w-5 !h-5" />
        </span>
      );
    });

    return (
      <>
        <span className="ml-5 min-w-[100px] h-[50px] flex items-center justify-center border-r border-dashed border-component-item">
          {t(i18n_page_settings_workspace.tabs.credits_transactions.table.credits_statistic_all_time.column.total)}
        </span>
        {header_users}
      </>
    );
  }

  return render_header();
}
